import React from 'react';
import { Box, Palette, Typography } from '@mui/material';
import { InformationChip } from '@europrocurement/flexy-components';
import { Link } from 'react-router-dom';
import { FaOptionIcon } from '@europrocurement/l2d-icons';

interface PrescripteurOffreSectionProps {
    prescripteur: {
        id: number;
        raisonSociale: string;
        codeComptable: string;
        urlToDetails?: string;
    };
    offre: { libelle: string };
    palette: Palette;
}

export const PrescripteurOffreSection: React.FunctionComponent<PrescripteurOffreSectionProps> =
    function ({ prescripteur, offre, palette }) {
        return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <Typography
                    variant="l2dbodys"
                    color="text.gris60"
                >
                    Prescripteur:
                </Typography>

                <Typography
                    variant="l2dbodys"
                    color="text.gris70"
                    sx={{ fontWeight: 500 }}
                >
                    {prescripteur.raisonSociale}
                </Typography>

                <Typography
                    variant="l2dbodys"
                    color="text.gris50"
                >
                    ({prescripteur.codeComptable})
                </Typography>
                {prescripteur.urlToDetails && (
                    <Link
                        to={prescripteur.urlToDetails}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: 'none' }}
                    >
                        <InformationChip
                            color={palette.grey[600]}
                            label={<Typography variant="l2dbodys">Fiche</Typography>}
                            icon={['fasl', 'arrow-up-right-from-square']}
                        />
                    </Link>
                )}
                <FaOptionIcon
                    icon={['fasl', 'chevron-right']}
                    sx={{ fontSize: '10px' }}
                    size="sm"
                />
                <Typography
                    variant="l2dbodys"
                    color="text.gris60"
                >
                    Offre:
                </Typography>
                <InformationChip
                    label={<Typography variant="l2dbodys">{offre?.libelle}</Typography>}
                    icon={['fasl', 'star-circle']}
                    color={palette.grey[600]}
                />
            </Box>
        );
    };
